import React, { useEffect, useState } from 'react';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import { uiRoutes } from '../../../../routes/ui/uiRoutes';
import PageHeading from '../../../../components/admin/common/PageHeading';
import { Link } from 'react-router-dom';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';

const AdminStudentList = () => {
  const [students, setStudents] = useState([]);
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();

  useEffect(() => {
    callAPI('get', 'admin/get-student-list', '');
  }, []);

  useEffect(() => {
    if (responce && Array.isArray(responce.data)) {
      setStudents(responce.data);
    }
  }, [responce]);

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          {/* Header Row */}
          <div className="row align-items-center mb-3">
            <div className="col-md-6">
              <PageHeading
                title="Student List"
                subTitle="Manage all student list."
              />
            </div>
            <div className="col-md-6 text-end">
              <Link to={uiRoutes.admin.student.add}>
                <button className="btn btn-primary">Add Student</button>
              </Link>
            </div>
          </div>

          {/* Table */}
          <div className="card p-3">
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead className="table-primary">
                  <tr>
                    <th>#</th>
                    <th>Full Name</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Program</th>
                    <th>Student Type</th>
                    <th>Fees</th>
                    <th>Address</th>
                  </tr>
                </thead>
                <tbody>
                  {students.length > 0 ? (
                    students.map((student, index) => (
                      <tr key={student.id}>
                        <td>{index + 1}</td>
                        <td>{student.first_name} {student.last_name}</td>
                        <td>{student.email}</td>
                        <td>{student.mobile_no}</td>
                        <td>
                          {student.student_programs?.[0]?.program?.name || 'N/A'}
                        </td>
                        <td>{student.student_type}</td>
                        <td>
                          {student.student_programs?.[0]?.program?.price || 'N/A'}
                        </td>
                        <td>{student.address || '-'}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">No students found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default AdminStudentList;
